module.exports = __webpack_public_path__ + "img/泊头除尘防爆模具.bb76448a.jpg";